export default {
  state: {
    bindInfo: [],  // 挂号类型
  },
  getters: {
    bindInfo: state => state.bindInfo
  },
  mutations: {
    setBindInfo(state, bindInfo){  // 挂号类型
      state.bindInfo = bindInfo;
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bindInfo.js